"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAggregateTelemetryGroupRequest extends new_item_1.default {
    constructor(newAggregateTelemetryGroupRequest) {
        super();
        this.groupType = newAggregateTelemetryGroupRequest.groupType;
        this.groupId = newAggregateTelemetryGroupRequest.groupId;
        this.start = newAggregateTelemetryGroupRequest.start;
        this.end = newAggregateTelemetryGroupRequest.end;
        this.status = newAggregateTelemetryGroupRequest.status;
    }
}
exports.default = NewAggregateTelemetryGroupRequest;
//# sourceMappingURL=new-aggregateTelemetryGroupRequest.js.map